var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"table-loader mr-2"}),_c('span',{staticClass:"table__status-text"},[_vm._v(_vm._s(_vm.props.loaderText))])])}
var staticRenderFns = []

export { render, staticRenderFns }